import { TDynamicFormConfig } from "@/features/Edit/dynamic-edit-form";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";

import { z } from "zod";

export const dynamicFormConfig = {
  id: z.number(),
  commitment: z.coerce.number().optional().nullable(),
  lpt_investment_duration: z.coerce.number().optional().nullable(),
  lpt_net_percentage_capital_called: z.coerce.number().optional().nullable(),
  lpt_loan_to_value: z.coerce.number().optional().nullable(),
  lpt_expected_distribution_rate: z.coerce.number().optional().nullable(),
  lpt_expected_investment_return: z.coerce.number().optional().nullable(),
  lpt_investment_period_end_date: z.preprocess(
    (val) => parseToDateValue(val),
    dateSchema,
  ),
  lpt_fund_vintage_start_date: z.preprocess(
    (val) => parseToDateValue(val),
    dateSchema,
  ),
  lpt_liquidity: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  vehicle: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  sector: z.string().nullable().optional(),
  product: z.string().nullable().optional(),
  asset_class_1: z.string().nullable().optional(),
  asset_class_2: z.string().nullable().optional(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
};

const DynamicFormSchema = z.object(dynamicFormConfig);
export const dynamicFormFields = DynamicFormSchema.keyof().enum;

export const dynamicNewFormConfigWithoutId: Omit<TDynamicFormConfig, "id"> =
  (() => {
    const { id, ...configWithoutId } = dynamicFormConfig;
    return configWithoutId;
  })();
